import { useEffect } from "react";

const setMetaTag = (name, content, attribute = "name") => {
  if (!content) return;
  let element = document.querySelector(`meta[${attribute}="${name}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, name);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
};

const setCanonical = (url) => {
  if (!url) return;
  let element = document.querySelector('link[rel="canonical"]');
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", "canonical");
    document.head.appendChild(element);
  }
  element.setAttribute("href", url);
};

const setStructuredData = (schemaObj) => {
  const schemaId = "dynamic-route-schema";
  let script = document.getElementById(schemaId);
  if (!schemaObj) {
    if (script) script.remove();
    return;
  }
  if (!script) {
    script = document.createElement("script");
    script.id = schemaId;
    script.type = "application/ld+json";
    document.head.appendChild(script);
  }
  script.text = JSON.stringify(schemaObj);
};

export default function SEO({
  title,
  description,
  keywords,
  canonical,
  ogTitle,
  ogDescription,
  ogImage,
  ogType = "website",
  schema,
}) {
  useEffect(() => {
    // 1. Page Title
    if (title) {
      document.title = title;
    }

    // 2. Standard Meta Tags
    if (description) setMetaTag("description", description);
    if (keywords) setMetaTag("keywords", keywords);

    // 3. Canonical URL
    if (canonical) setCanonical(canonical);

    // 4. Open Graph Tags
    const effectiveOgTitle = ogTitle || title;
    const effectiveOgDesc = ogDescription || description;
    if (effectiveOgTitle) setMetaTag("og:title", effectiveOgTitle, "property");
    if (effectiveOgDesc) setMetaTag("og:description", effectiveOgDesc, "property");
    if (canonical) setMetaTag("og:url", canonical, "property");
    if (ogType) setMetaTag("og:type", ogType, "property");
    if (ogImage) setMetaTag("og:image", ogImage, "property");

    // 5. Twitter Card Tags
    setMetaTag("twitter:card", "summary_large_image");
    if (effectiveOgTitle) setMetaTag("twitter:title", effectiveOgTitle);
    if (effectiveOgDesc) setMetaTag("twitter:description", effectiveOgDesc);
    if (ogImage) setMetaTag("twitter:image", ogImage);

    // 6. Dynamic JSON-LD Schema
    if (schema) {
      setStructuredData(schema);
    }

    return () => {
      // Optional cleanup on unmount
      const dynamicSchema = document.getElementById("dynamic-route-schema");
      if (dynamicSchema) dynamicSchema.remove();
    };
  }, [title, description, keywords, canonical, ogTitle, ogDescription, ogImage, ogType, schema]);

  return null;
}
